module.exports = __webpack_public_path__ + "static/media/check.2aa36d20.svg";